import React, { useEffect, useState } from "react";
import SearchBar from "../../../components/admin/usable/SearchBar";
import AddButton from "../../../components/admin/usable/AddButton";
import Pagination from "@mui/material/Pagination";
import TableLoader from "../../../components/admin/usable/TableLoader";
import EditButton from "../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import { useNavigate } from "react-router";
import { deleteTour, getTourList } from "../../../api/admin/tourApi";
import AddUser from "./AddUser";
import { getCustomers } from "../../../api/admin/userApi";

const UserList = () => {
  const navigate = useNavigate();
  const [CustomerData, setCustomerData] = useState([]);
  const [FilteredData, setFilteredData] = useState([]);
  const [Search, setSearch] = useState("");
  const [Page, setPage] = useState(1);
  const [Limit, setLimit] = useState(20);
  const [PageData, setPageData] = useState("");
  useEffect(() => {
    getCustomers(setCustomerData, Page, Limit, setPageData);
  }, [Page, Limit]);

  useEffect(() => {
    if (Search.trim() === "") {
      setFilteredData(CustomerData);
    } else {
      const result = CustomerData.filter((item) =>
        item.fullName.toLowerCase().includes(Search.toLowerCase()),
      );
      setFilteredData(result);
    }
  }, [Search, CustomerData]);
  const handleDelete = (item) => {
    const id = item.id;
    deleteTour(setCustomerData, setPageData, Page, Limit, id);
  };
  return (
    <div className="space-y-5">
      <div className="flex justify-between items-center">
        <SearchBar
          onChange={(e) => setSearch(e.target.value)}
          text="Search User by name"
        />
        <div></div>
      </div>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                ID
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Full Name
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Email
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Phone Number
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Customer?
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Welcomed?
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Status
              </th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                CreatedAt
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {FilteredData.length > 0 ? (
              <>
                {FilteredData.map((item, index) => {
                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {index + 1}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.fullName}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.email}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.phoneNumber}
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        <span
                          className={`px-2 py-1 ${
                            item.isCustomer === 1
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          } rounded text-xs`}
                        >
                          {item.isCustomer === 1 ? "Yes" : "No"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        <span
                          className={`px-2 py-1 ${
                            item.isWelcomed === 1
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          } rounded text-xs`}
                        >
                          {item.isWelcomed === 1 ? "Yes" : "No"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        <span
                          className={`px-2 py-1 ${
                            item.status === 1
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          } rounded text-xs`}
                        >
                          {item.status === 1 ? "Active" : "Inactive"}
                        </span>
                      </td>

                      <td className="px-4 py-3 text-sm text-gray-700 text-nowrap">
                        {item.createdAt.slice(0, 10)}
                      </td>
                    </tr>
                  );
                })}
              </>
            ) : (
              <TableLoader colSpan={11} />
            )}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-xs">
          Showing {(Page - 1) * Limit + 1} to{" "}
          {(Page - 1) * Limit + CustomerData.length} of {PageData} entries
        </p>
        <Pagination
          count={PageData || 1}
          page={Page}
          onChange={(event, value) => setPage(value)}
        />
      </div>
    </div>
  );
};

export default UserList;
